import Chart from "react-apexcharts";
import { Loading } from "../../../componentes/loading/loading";
import DropDown from "../../../componentes/dropdown/dropdown";
import { useEffect, useState } from "react";

const C = {
    bg: "#F0F4F8",
    surface: "#FFFFFF",
    surfaceAlt: "#F8FAFC",
    border: "#E2E8F0",
    borderStrong: "#CBD5E1",
    primary: "#0EA5E9",
    primaryDark: "#0284C7",
    secondary: "#6366F1",
    accent: "#10B981",
    danger: "#EF4444",
    warn: "#F59E0B",
    purple: "#8B5CF6",
    text: "#0F172A",
    textMid: "#475569",
    muted: "#94A3B8",
    c1: "#0EA5E9",
    c2: "#6366F1",
    c3: "#10B981",
    c4: "#F59E0B",
    c5: "#EF4444",
};

export function ProducaoMensal({ service, filial, funcionario }) {
    const monthLabels = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];

    const [ano, setAno] = useState(2026);
    const [report, setProducaoMensal] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchProducaoMensal();
    }, [ano, filial, funcionario])

    const fetchProducaoMensal = () => {
        setLoading(true);
        service.relatorioProducaoMensal(filial, funcionario, ano)
            .then(res => {
                setProducaoMensal(res.data);
            })
            .catch(err => {
                console.error("Erro ao carregar relatório:", err);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    function mapMonthsToArray(map) {
        const arr = Array(12).fill(0);
        if (!map) return arr;
        Object.keys(map).forEach((k) => {
            const idx = Number(k) - 1;
            if (!Number.isNaN(idx) && idx >= 0 && idx < 12) arr[idx] = Number(map[k]) || 0;
        });
        return arr;
    }

    const caixasPorMes = mapMonthsToArray(report.caixasPorMes);
    const paletesPorMes = mapMonthsToArray(report.paletesPorMes);

    const options = {
        chart: {
            type: "area",
            zoom: { enabled: false },
        },
        xaxis: {
            categories: monthLabels,
        },
        yaxis: {
            type: "logarithmic",
            title: {
                text: "Quantidade",
            },
        },
        stroke: {
            curve: "smooth",
            width: 2,
        },

        markers: {
            size: 4,
        },
        legend: {
            position: "top",
        },
        colors: ["#3B82F6", "#10B981"],
    };

    const series = [
        { name: "Caixas", data: caixasPorMes },
        { name: "Paletes", data: paletesPorMes },
    ];

    const selectStyle = {
        background: C.surfaceAlt,
        border: `1.5px solid ${C.border}`,
        color: C.textMid,
        padding: "6.4px 14px",
        borderRadius: 8,
        cursor: "pointer",
        fontSize: 12,
        fontWeight: 600,
        fontFamily: "var(--font-sans)",
    };

    return (
        <div className="relative">
            <div className="flex justify-between absolute z-[50]">

                <select
                    value={ano}
                    onChange={e => setAno(e.target.value)}
                    style={selectStyle}
                >
                    {[2025, 2026].map(f => <option key={f} value={f}>{f}</option>)}
                </select>
            </div>

            <div style={{ height: 320 }}>
                {!loading ? (
                    <Chart options={options} series={series} type="area" height="100%" />
                ) : (
                    <Loading />
                )}
            </div>
        </div>
    );
}